import React from 'react';
import { TextInput, ActionIcon } from '@mantine/core';
import { IconSearch, IconX } from '@tabler/icons-react';
import { LoadingState } from '../../../common/loading';
import { useTranslation } from 'react-i18next';
import type { SearchInputProps } from '../types';
import styles from '../AddressSearchBar.module.css';

export const SearchInput = React.memo<SearchInputProps>(
  ({
    query,
    onQueryChange,
    onKeyDown,
    onFocus,
    onBlur,
    onClear,
    isLoading,
    disabled,
    placeholder,
    inputRef,
  }) => {
    const { t } = useTranslation();

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      onQueryChange(event.target.value);
    };

    return (
      <TextInput
        ref={inputRef}
        variant="unstyled"
        placeholder={placeholder || t('search.address.placeholder')}
        value={query}
        onChange={handleInputChange}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        autoComplete="off"
        leftSection={
          isLoading ? (
            <LoadingState mode="spinner" size="xs" />
          ) : (
            <IconSearch size={16} />
          )
        }
        rightSection={
          query && (
            <ActionIcon
              variant="subtle"
              color="gray"
              onClick={onClear}
              aria-label={t('search.address.clearAddress')}
              size="sm"
            >
              <IconX size={16} />
            </ActionIcon>
          )
        }
        className={styles.input}
        aria-label={t('search.address.placeholder')}
        aria-expanded={false} // This will be controlled by parent
        aria-haspopup="listbox"
        role="combobox"
        aria-autocomplete="list"
      />
    );
  }
);
